import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-undo",
  "use": "icon-undo-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-undo\"><path d=\"M16 27.8H7.8v-2H16c5.6 0 10-4.4 10-10s-4.4-10-10-10H7.8L10 8 8.6 9.4 4 4.8 8.8 0l1.4 1.4-2.4 2.4H16c6.6 0 12 5.4 12 12s-5.4 12-12 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol